var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"mb-4"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('legend',[_vm._v(_vm._s(_vm.title))]),_c('shipping-same-as-billing-address')],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }